/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Stack } from '@fluentui/react/lib/Stack';
import { ITextProps, ITextStyles } from '@fluentui/react/lib/Text';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import * as React from 'react';
import { defineMessages } from 'react-intl';
import { LuisText } from 'src/core/components/LuisText';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getScopedTheme } from 'src/core/themes/luisStylist';

const scopedTheme = getScopedTheme('AdvancedOptionsPane');

const messages = defineMessages({
    noOptions: {
        id: 'luis.intentLabelingSidePane.advancedOptions.listEntity.noOptions',
        defaultMessage: 'No advanced options.'
    }
});

const textStyles = classNamesFunction<ITextProps, ITextStyles>()({
    root: { fontSize: 12, color: scopedTheme.emptyTextColor }
});

/**
 * Renders advanced options for a list entity.
 * Currently there is no advanced options for list entities.
 */
export const NoAdvancedOptions = () => {
    const { localize } = useLocalization();

    return (
        <Stack>
            <LuisText styles={textStyles}>{localize(messages.noOptions)}</LuisText>
        </Stack>
    );
};
